import { LinkData } from 'src/containers/ProjectDiagram/types/model';
import { isModelConceptRelationship } from 'src/containers/ProjectDiagram/utils/data';
import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';

export const getRelationshipDomainsAndRanges = (
  linkDataArray: LinkData[],
  relationshipIri: string
) => {
  const domains = new Set<string>();
  const ranges = new Set<string>();
  linkDataArray.forEach((data) => {
    if (!isModelConceptRelationship(data)) {
      return;
    }

    if (data.value === relationshipIri) {
      const fromIri = data.from && getModelConceptClassValue(data.from);
      const toIri = data.to && getModelConceptClassValue(data.to);
      if (fromIri) {
        domains.add(fromIri);
      }
      if (toIri) {
        ranges.add(toIri);
      }
    }
  });

  return { domains, ranges };
};
